import { rewriteAzureBlobUrlToContentDomain } from './azureBlobUrl'

/**
 * Operator JSON (Azure / legacy) uses inconsistent casing and field names for the logo URL.
 */
export type OperatorLogoBlobRef = {
  fileId: string
  fileExt: string
}

function scalarString(o: Record<string, unknown>, ...keys: string[]): string | null {
  for (const k of keys) {
    const v = o[k]
    if (typeof v === 'string' && v.trim().length > 0) return v.trim()
  }
  return null
}

export function getOperatorLogoUrl(operator: unknown): string | null {
  if (!operator || typeof operator !== 'object') return null
  const o = operator as Record<string, unknown>
  const keys = [
    'logoImageSasUrl',
    'LogoImageSasUrl',
    'logoImageUrl',
    'LogoImageUrl',
    'operatorLogoUrl',
    'OperatorLogoUrl',
    'operatorLogoSasUrl',
    'OperatorLogoSasUrl',
    'logoUrl',
    'LogoUrl',
    'logoURL',
    'operatorLogo',
    'OperatorLogo',
    'imageUrl',
    'ImageUrl',
    'ImageURL',
    'logo',
    'Logo',
    'companyLogo',
    'CompanyLogo',
    'operatorImageUrl',
    'OperatorImageUrl',
    'brandLogo',
    'BrandLogo',
  ]
  for (const k of keys) {
    const v = o[k]
    if (typeof v === 'string' && v.trim().length > 0) {
      return rewriteAzureBlobUrlToContentDomain(v.trim())
    }
    if (v && typeof v === 'object' && !Array.isArray(v)) {
      const nested = v as Record<string, unknown>
      for (const nk of ['url', 'Url', 'src', 'Src', 'href', 'Href']) {
        const u = nested[nk]
        if (typeof u === 'string' && u.trim().length > 0) {
          return rewriteAzureBlobUrlToContentDomain(u.trim())
        }
      }
    }
  }
  return null
}

/** Legacy operator logo stored as a downloaded blob (`id` + `fileExt` on the operator row). */
export function getOperatorLogoBlobRef(operator: unknown): OperatorLogoBlobRef | null {
  if (!operator || typeof operator !== 'object') return null
  const o = operator as Record<string, unknown>
  const fileExt = scalarString(o, 'fileExt', 'FileExt')
  const fileId = scalarString(o, 'id', 'Id', 'operatorId', 'OperatorId')
  if (!fileExt || !fileId) return null
  return { fileId, fileExt }
}
